import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { OfficeNotesBO } from './client-onboardinglist.model';
import { ErrorService } from 'src/app/error.service';

@Injectable({
  providedIn: 'root'
})
export class clientOnboardinglistService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  GetTemplateNameList(): Observable<[{ Key: string, Value: string }]> {
    let url = "api/ClientAgreement/GetTemplateDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
    }
 SaveOfficeNote(note:OfficeNotesBO):Observable<any> {
    let url = "api/ClientAgreement/SaveClientOfficeNotes";
    return this.http.post<any>(url , note, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getLov(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Lov/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  DeleteClientAggrementInfo(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Client/DeleteClientAggrement?";
    return this.http.delete<number>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}